export const EVENT = {
  PERMISSIONS_CHANGED: 'PERMISSIONS_CHANGED',
}
